import HtmlToReact from 'html-to-react';

const HtmlToReactParser = HtmlToReact.Parser;
const htmlToReactParser = new HtmlToReactParser();

const isValidNode = () => true;

const TemplateParser = (props) => {
  const { products, settings, start, end, type } = props;

  const firstProduct = start || 1;
  const lastProduct = end || products.length;
  const productArray = products.slice(firstProduct - 1, lastProduct);
  return productArray.map((product, index) =>
    htmlToReactParser.parseWithInstructions(
      props.children,
      isValidNode,
      props.processingInstructions(
        product,
        type,
        settings,
        parseInt(firstProduct, 10) + index,
        products.length
      )
    )
  );
};

export default TemplateParser;
